import { createRouter, createWebHistory } from 'vue-router';

import useAuth from '@/hooks/auth';
import AccessDenied from '../components/Utilities/AccessDenied.vue';
import SeaRequired from '../components/Utilities/SeaRequired.vue';
import ApplicationDetailedSummary from '../components/ApplicationForm/ApplicationDetailedSummary.vue';
import ApplicationsTable from '../components/Application/ApplicationsTable.vue';
import ApplicationStepper from '../components/ApplicationForm/ApplicationStepper.vue';
import ComplexTable from '../components/Complexes/ComplexTable.vue';
import DepositPayment from '../components/ApplicationForm/DepositPayment.vue';
import Emails from '../components/Email/EmailTable.vue';
import EmailWysiwyg from '../components/Email/EmailWysiwyg.vue';
import Home from '../components/Home.vue';
import Loading from '../components/Utilities/Loading.vue';
import PlacementTable from '../components/Placement/PlacementTable.vue';
import UsersTable from '../components/Users/UsersTable.vue';
import SessionStepper from '../components/Sessions/SessionStepper.vue';
import SessionsTable from '../components/Sessions/SessionsTable.vue';
import StudentLanding from '../components/Landing/StudentLanding.vue';
import SubmitComplex from '../components/Complexes/SubmitComplex.vue';
import SubmitSession from '../components/Sessions/SubmitSession.vue';
import SubmitUnit from '../components/Units/SubmitUnit.vue';
import Error404 from '../components/Utilities/Error404.vue';

const routes = [
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDenied,
  },
  {
    path: '/sea-required',
    name: 'SeaRequired',
    component: SeaRequired,
  },
  {
    path: '/application/detail',
    name: 'ApplicationDetailedSummary',
    component: ApplicationDetailedSummary,
    meta: { requiresAuth: true },
  },
  {
    path: '/applications',
    name: 'ApplicationsTable',
    component: ApplicationsTable,
    meta: { requiresAuth: true },
  },
  {
    path: '/create-application',
    name: 'ApplicationStepper',
    component: ApplicationStepper,
    meta: { requiresAuth: true },
  },
  {
    path: '/complexes',
    name: 'ComplexTable',
    component: ComplexTable,
    meta: { requiresAuth: true },
  },
  {
    path: '/deposit/:applicationId',
    name: 'DepositPayment',
    component: DepositPayment,
    meta: { requiresAuth: true },
  },
  {
    path: '/emails',
    name: 'Emails',
    component: Emails,
    meta: { requiresAuth: true },
  },
  {
    path: '/emailWysiwyg',
    name: 'EmailWysiwyg',
    component: EmailWysiwyg,
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/loading',
    name: 'Loading',
    component: Loading,
    meta: { requiresAuth: true },
  },
  {
    path: '/placements',
    name: 'PlacementTable',
    component: PlacementTable,
    meta: { requiresAuth: true },
  },
  {
    path: '/session-stepper',
    name: 'SessionStepper',
    component: SessionStepper,
    meta: { requiresAuth: true },
  },
  {
    path: '/sessions',
    name: 'SessionsTable',
    component: SessionsTable,
    meta: { requiresAuth: true },
  },
  {
    path: '/studentLanding',
    name: 'StudentLanding',
    component: StudentLanding,
    meta: { requiresAuth: true },
  },
  {
    path: '/submit-complex',
    name: 'SubmitComplex',
    component: SubmitComplex,
    meta: { requiresAuth: true },
  },
  {
    path: '/submit-session',
    name: 'SubmitSession',
    component: SubmitSession,
    meta: { requiresAuth: true },
  },
  {
    path: '/submit-unit',
    name: 'SubmitUnit',
    component: SubmitUnit,
    meta: { requiresAuth: true },
  },
  {
    path: '/users',
    name: 'UsersTable',
    component: UsersTable,
    meta: { requiresAuth: true },
  },
  {
    path: '/:pathMatch(.*)',
    name: 'Error404',
    component: Error404,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  // Allow access to non-auth routes
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    return true;
  }

  const auth = useAuth();
  const user = await auth.getUser();

  if (!user) {
    return '/access-denied';
  }

  // Check SEA status for OIP students (skip for sea-required page itself)
  if (to.name !== 'SeaRequired') {
    const isOipStudent = sessionStorage.getItem('isOipStudent');
    const seaStatus = sessionStorage.getItem('seaStatus');

    if (isOipStudent === 'true' && seaStatus !== 'true') {
      return '/sea-required';
    }
  }

  return true;
});

export default router;
